import DgTable from 'styles/UI/Table/DgTable';
import { useAdminPackageQuery } from '../hooks/react-query/useAdminPackageQuery';
import AdminPackageTableColumn from './AdminPackageTableColumn';

const AdminPackageTable = ({
	onEditSettingsHandler,
	onDeletePackageHandler,
}: {
	onEditSettingsHandler?: (val: any) => void;
	onDeletePackageHandler?: (val: any) => void;
}) => {
	const { data: packages, isFetching: packageIsFetching } = useAdminPackageQuery();

	return (
		<DgTable
			rowKey='id'
			columns={AdminPackageTableColumn(onEditSettingsHandler, onDeletePackageHandler)}
			dataSource={packages?.data}
			count={packages?.data.length}
			loading={packageIsFetching}
		/>
	);
};

export default AdminPackageTable;
